import { render } from "./TheTuyenDuongThuGomRac.vue?vue&type=template&id=1d0e6a6e"
import script from "./TheTuyenDuongThuGomRac.vue?vue&type=script&lang=js"
export * from "./TheTuyenDuongThuGomRac.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__